export default function (locale: string) {
    async function fetchLocalizeJson() {
        const route = useRoute();
        const { data } = await useFetch(`/${locale}/${route?.params?.category}/${route?.params?.slug}/api/localize`);

        return data?.value;
    }

    return { fetchLocalizeJson }
  }
